import {
  GET_ATTRIBUTES,
  GET_ATTRIBUTES_SUCCESS,
  GET_ATTRIBUTES_FAIL,
  GET_ATTRIBUTE_BY_ID_SUCCESS,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
};

const Attribute = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ATTRIBUTES:
      return {
        ...state,
        loading: true,
      };
    case GET_ATTRIBUTES_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        loading: false,
      };
    case GET_ATTRIBUTE_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_ATTRIBUTES_FAIL:
      return {
        ...state,
        error: payload,
      };
    default:
      return state;
  }
};

export default Attribute;
